import { render } from "./SimpleForm.vue?vue&type=template&id=4ebad724"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"
script.render = render

export default script